import { toArray } from 'lodash';

export default class SplitDropdown {

  constructor(element) {

    this.el = element;
    this.downloadBtn = this.el.querySelector('.primary-btn:first-child');
    this.arrowBtn = this.el.querySelector('.split-dropdown > .primary-btn');
    this.contentContainer = this.el.querySelector('.split-dropdown--content');
    this.downloadOptions = toArray(this.el.querySelectorAll('.split-dropdown--content a'));
    this.isOpen = false;
    this.registerEvents();
  }

  registerEvents() {

    this.downloadBtn.addEventListener('click', this.openDropdown.bind(this));
    this.arrowBtn.addEventListener('click', this.openDropdown.bind(this));
    this.downloadOptions.forEach(option => {

      option.addEventListener('click', (e) => this.handleDownload(e));
    });
  }

  openDropdown() {

    if (this.isOpen) {

      this.contentContainer.classList.remove('is-open');
      return;
    }
    this.isOpen = true;
    this.contentContainer.classList.add('is-open');
    this.handleOutsideClick();
  }

  handleDownload(e) {

    this.contentContainer.classList.remove('is-open');
    this.downloadBtn.classList.add('is-downloading');
    this.downloadBtn.innerHTML = 'Downloading...';

    setTimeout(()=> { 
      this.downloadBtn.classList.remove('is-downloading');
      this.downloadBtn.innerHTML = 'Download';
    }, 2000);
    this.isOpen = false;
  }

  handleOutsideClick() {
    window.addEventListener('mouseup', (e) => {
      if (e.target !== this.contentContainer || e.target !== this.downloadOptions) {

        this.contentContainer.classList.remove('is-open');
        this.isOpen = false;
      }
    });
  }
};
